module.exports = __webpack_public_path__ + "static/media/catalouge-21.6c002295.jpg";